import { createSlice, PayloadAction, WritableDraft } from "@reduxjs/toolkit";
import { Alert } from "../types/index.js";
import { patchRevision, resetRevision } from "./revisions.js";

const initialState: Alert[] = [];

const createAlert = (text: string, type: Alert["type"] = "error"): Alert => ({
  id: crypto.randomUUID(),
  text,
  type,
});

const addAlert = (state: WritableDraft<Alert[]>, alert: Alert) => {
  state.push(alert);
};

const createAndAddAlert = (
  state: WritableDraft<Alert[]>,
  text: string,
  type?: Alert["type"],
) => {
  addAlert(state, createAlert(text, type));
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: (create) => ({
    showAlert: create.preparedReducer(
      (text: string, type?: Alert["type"]) => ({
        payload: createAlert(text, type),
      }),
      (state, action: PayloadAction<Alert>) => addAlert(state, action.payload),
    ),

    removeAlert: create.preparedReducer(
      (id: string) => ({ payload: id }),
      (state, action) => state.filter((alert) => alert.id !== action.payload),
    ),
  }),
  extraReducers: (builder) => {
    builder.addCase(resetRevision.rejected, (state, action) => {
      if (action.meta.condition) {
        createAndAddAlert(state, "Zurücksetzen nicht möglich!");
      }
    });
    builder.addCase(patchRevision.rejected, (state, action) => {
      if (action.meta.condition) {
        createAndAddAlert(state, "Favorisieren nicht möglich!");
      }
    });
  },
});

export const { showAlert, removeAlert } = alertsSlice.actions;

export default alertsSlice.reducer;
